import React from 'react';

export default class Page6 extends React.Component {

    render() {

        const {pageData} = this.props;

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">

                                            <div className="mobile-scroll">
                                                <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                       className="ilead_v_sport tablesrink people_active_radio">
                                                    <tbody>
                                                    <tr>
                                                        <th width="30%" align="left" valign="center"
                                                            className="green_curve ">&nbsp;&nbsp;&nbsp;Item
                                                        </th>
                                                        <th width="50%" align="left" valign="top" colSpan="9"
                                                            className=" green_curve1">&nbsp;&nbsp;Self
                                                            Assessment
                                                        </th>

                                                    </tr>
                                                    <tr>
                                                    </tr>
                                                    <tr>
                                                        <td width="40%" align="left" valign="top"
                                                            className="lightgreen"><span
                                                            className="subtitle-table"></span></td>
                                                        <td width="5%" align="center" valign="center"
                                                            className=" roundbg"><span>1</span>
                                                        </td>
                                                        <td width="5%" align="center" valign="center"
                                                            className="roundbg"><span>2</span>
                                                        </td>
                                                        <td width="5%" align="center" valign="center"
                                                            className="roundbg"><span>3</span>
                                                        </td>
                                                        <td width="5%" align="center" valign="center"
                                                            className="roundbg"><span>4</span>
                                                        </td>
                                                        <td width="5%" align="center" valign="center"
                                                            className="roundbg"><span>5</span>
                                                        </td>
                                                        <td width="5%" align="center" valign="center"
                                                            className="roundbg"><span>6</span>
                                                        </td>
                                                        <td width="5%" align="center" valign="center"
                                                            className="roundbg"><span>7</span>
                                                        </td>
                                                        <td width="5%" align="center" valign="center"
                                                            className="roundbg"><span>8</span>
                                                        </td>
                                                        <td width="5%" align="center" valign="center"
                                                            className="roundbg"><span>9</span>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen">
                                                            <ol className="tableliclass" start="1">
                                                                <li><p className="">You are influential and
                                                                    persuasive in the way you put your point
                                                                    across.</p></li>
                                                            </ol>
                                                        </td>
                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item1"
                                                                   id="11"
                                                                   value="1"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item1 === 1}/>
                                                            <label className="cursor-pointer" htmlFor="11">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item1"
                                                                   id="12"
                                                                   value="2"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item1 === 2}/>
                                                            <label className="cursor-pointer" htmlFor="12">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item1"
                                                                   id="13"
                                                                   value="3"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item1 === 3}/>
                                                                   <label className="cursor-pointer" htmlFor="13">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item1"
                                                                   id="14"
                                                                   value="4"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item1 === 4}/>
                                                                   <label className="cursor-pointer" htmlFor="14">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item1"
                                                                   id="15"
                                                                   value="5"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item1 === 5}/>
                                                                   <label className="cursor-pointer" htmlFor="15">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item1"
                                                                   id="16"
                                                                   value="6"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item1 === 6}/>
                                                                   <label className="cursor-pointer" htmlFor="16">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item1"
                                                                   id="17"
                                                                   value="7"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item1 === 7}/>
                                                                   <label className="cursor-pointer" htmlFor="17">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item1"
                                                                   id="18"
                                                                   value="8"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item1 === 8}/>
                                                                   <label className="cursor-pointer" htmlFor="18">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item1"
                                                                   id="19"
                                                                   value="9"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item1 === 9}/>
                                                                   <label className="cursor-pointer" htmlFor="19">&nbsp;</label>
                                                        </td>


                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">
                                                            <ol className="tableliclass" start="2">
                                                                <li><p className="">You put across the key
                                                                    pieces of data that make your idea
                                                                    worthwhile.</p></li>
                                                            </ol>
                                                        </td>
                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item2"
                                                                   id="21"
                                                                   value="1"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item2 === 1}/>
                                                            <label className="cursor-pointer" htmlFor="21">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item2"
                                                                   id="22"
                                                                   value="2"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item2 === 2}/>
                                                            <label className="cursor-pointer" htmlFor="22">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item2"
                                                                   id="23"
                                                                   value="3"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item2 === 3}/>
                                                            <label className="cursor-pointer" htmlFor="23">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item2"
                                                                   id="24"
                                                                   value="4"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item2 === 4}/>
                                                            <label className="cursor-pointer" htmlFor="24">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item2"
                                                                   id="25"
                                                                   value="5"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item2 === 5}/>
                                                            <label className="cursor-pointer" htmlFor="25">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item2"
                                                                   id="26"
                                                                   value="6"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item2 === 6}/>
                                                            <label className="cursor-pointer" htmlFor="26">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item2"
                                                                   id="27"
                                                                   value="7"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item2 === 7}/>
                                                            <label className="cursor-pointer" htmlFor="27">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item2"
                                                                   id="28"
                                                                   value="8"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item2 === 8}/>
                                                            <label className="cursor-pointer" htmlFor="28">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item2"
                                                                   id="29"
                                                                   value="9"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item2 === 9}/>
                                                            <label className="cursor-pointer" htmlFor="29">&nbsp;</label>
                                                        </td>


                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen">
                                                            <ol className="tableliclass" start="3">
                                                                <li><p className="">You place the emphasis on
                                                                    the opportunities that your idea will
                                                                    bring.</p></li>
                                                            </ol>
                                                        </td>
                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item3"
                                                                   id="31"
                                                                   value="1"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item3 === 1}/>
                                                            <label className="cursor-pointer" htmlFor="31">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item3"
                                                                   id="32"
                                                                   value="2"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item3 === 2}/>
                                                            <label className="cursor-pointer" htmlFor="32">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item3"
                                                                   id="33"
                                                                   value="3"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item3 === 3}/>
                                                            <label className="cursor-pointer" htmlFor="33">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item3"
                                                                   id="34"
                                                                   value="4"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item3 === 4}/>
                                                            <label className="cursor-pointer" htmlFor="34">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item3"
                                                                   id="35"
                                                                   value="5"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item3 === 5}/>
                                                            <label className="cursor-pointer" htmlFor="35">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item3"
                                                                   id="36"
                                                                   value="6"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item3 === 6}/>
                                                            <label className="cursor-pointer" htmlFor="36">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item3"
                                                                   id="37"
                                                                   value="7"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item3 === 7}/>
                                                            <label className="cursor-pointer" htmlFor="37">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item3"
                                                                   id="38"
                                                                   value="8"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item3 === 8}/>
                                                            <label className="cursor-pointer" htmlFor="38">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item3"
                                                                   id="39"
                                                                   value="9"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item3 === 9}/>
                                                            <label className="cursor-pointer" htmlFor="39">&nbsp;</label>
                                                        </td>


                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">
                                                            <ol className="tableliclass" start="4">
                                                                <li><p className="">You demonstrate high levels
                                                                    of persistence in the face of obstacles and
                                                                    challenges.</p></li>
                                                            </ol>
                                                        </td>
                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item4"
                                                                   id="41"
                                                                   value="1"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item4 === 1}/>
                                                            <label className="cursor-pointer" htmlFor="41">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item4"
                                                                   id="42"
                                                                   value="2"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item4 === 2}/>
                                                            <label className="cursor-pointer" htmlFor="42">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item4"
                                                                   id="43"
                                                                   value="3"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item4 === 3}/>
                                                            <label className="cursor-pointer" htmlFor="43">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item4"
                                                                   id="44"
                                                                   value="4"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item4 === 4}/>
                                                            <label className="cursor-pointer" htmlFor="44">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item4"
                                                                   id="45"
                                                                   value="5"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item4 === 5}/>
                                                            <label className="cursor-pointer" htmlFor="45">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item4"
                                                                   id="46"
                                                                   value="6"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item4 === 6}/>
                                                            <label className="cursor-pointer" htmlFor="46">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item4"
                                                                   id="47"
                                                                   value="7"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item4 === 7}/>
                                                            <label className="cursor-pointer" htmlFor="47">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item4"
                                                                   id="48"
                                                                   value="8"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item4 === 8}/>
                                                            <label className="cursor-pointer" htmlFor="48">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item4"
                                                                   id="49"
                                                                   value="9"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item4 === 9}/>
                                                            <label className="cursor-pointer" htmlFor="49">&nbsp;</label>
                                                        </td>


                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen">
                                                            <ol className="tableliclass" start="5">
                                                                <li><p className="">You are energetic and
                                                                    enthusiastic when sharing your own vision of
                                                                    what can be achieved.</p></li>
                                                            </ol>
                                                        </td>
                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item5"
                                                                   id="51"
                                                                   value="1"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item5 === 1}/>
                                                            <label className="cursor-pointer" htmlFor="51">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item5"
                                                                   id="52"
                                                                   value="2"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item5 === 2}/>
                                                            <label className="cursor-pointer" htmlFor="52">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item5"
                                                                   id="53"
                                                                   value="3"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item5 === 3}/>
                                                            <label className="cursor-pointer" htmlFor="53">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item5"
                                                                   id="54"
                                                                   value="4"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item5 === 4}/>
                                                            <label className="cursor-pointer" htmlFor="54">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item5"
                                                                   id="55"
                                                                   value="5"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item5 === 5}/>
                                                            <label className="cursor-pointer" htmlFor="55">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item5"
                                                                   id="56"
                                                                   value="6"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item5 === 6}/>
                                                            <label className="cursor-pointer" htmlFor="56">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item5"
                                                                   id="57"
                                                                   value="7"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item5 === 7}/>
                                                            <label className="cursor-pointer" htmlFor="57">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item5"
                                                                   id="58"
                                                                   value="8"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item5 === 8}/>
                                                            <label className="cursor-pointer" htmlFor="58">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item5"
                                                                   id="59"
                                                                   value="9"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item5 === 9}/>
                                                            <label className="cursor-pointer" htmlFor="59">&nbsp;</label>
                                                        </td>


                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">
                                                            <ol className="tableliclass" start="6">
                                                                <li><p className="">You use logic and high-level
                                                                    analysis to cut through complexity for a
                                                                    clear solution.</p></li>
                                                            </ol>
                                                        </td>
                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item6"
                                                                   id="I1"
                                                                   value="1"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item6 === 1}/>
                                                            <label className="cursor-pointer" htmlFor="I1">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item6"
                                                                   id="I2"
                                                                   value="2"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item6 === 2}/>
                                                            <label className="cursor-pointer" htmlFor="I2">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item6"
                                                                   id="I3"
                                                                   value="3"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item6 === 3}/>
                                                            <label className="cursor-pointer" htmlFor="I3">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item6"
                                                                   id="I4"
                                                                   value="4"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item6 === 4}/>
                                                            <label className="cursor-pointer" htmlFor="I4">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item6"
                                                                   id="I5"
                                                                   value="5"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item6 === 5}/>
                                                            <label className="cursor-pointer" htmlFor="I5">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item6"
                                                                   id="I6"
                                                                   value="6"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item6 === 6}/>
                                                            <label className="cursor-pointer" htmlFor="I6">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item6"
                                                                   id="I7"
                                                                   value="7"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item6 === 7}/>
                                                            <label className="cursor-pointer" htmlFor="I7">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item6"
                                                                   id="I8"
                                                                   value="8"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item6 === 8}/>
                                                            <label className="cursor-pointer" htmlFor="I8">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item6"
                                                                   id="I9"
                                                                   value="9"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item6 === 9}/>
                                                            <label className="cursor-pointer" htmlFor="I9">&nbsp;</label>
                                                        </td>


                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen">
                                                            <ol className="tableliclass" start="7">
                                                                <li><p className="">You underline the unique
                                                                    selling points of your idea.</p></li>
                                                            </ol>
                                                        </td>
                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item7"
                                                                   id="71"
                                                                   value="1"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item7 === 1}/>
                                                            <label className="cursor-pointer" htmlFor="71">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item7"
                                                                   id="72"
                                                                   value="2"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item7 === 2}/>
                                                            <label className="cursor-pointer" htmlFor="72">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item7"
                                                                   id="73"
                                                                   value="3"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item7 === 3}/>
                                                            <label className="cursor-pointer" htmlFor="73">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item7"
                                                                   id="74"
                                                                   value="4"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item7 === 4}/>
                                                            <label className="cursor-pointer" htmlFor="74">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item7"
                                                                   id="75"
                                                                   value="5"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item7 === 5}/>
                                                            <label className="cursor-pointer" htmlFor="75">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item7"
                                                                   id="76"
                                                                   value="6"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item7 === 6}/>
                                                            <label className="cursor-pointer" htmlFor="76">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item7"
                                                                   id="77"
                                                                   value="7"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item7 === 7}/>
                                                            <label className="cursor-pointer" htmlFor="77">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item7"
                                                                   id="78"
                                                                   value="8"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item7 === 8}/>
                                                            <label className="cursor-pointer" htmlFor="78">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item7"
                                                                   id="79"
                                                                   value="9"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item7 === 9}/>
                                                            <label className="cursor-pointer" htmlFor="79">&nbsp;</label>
                                                        </td>


                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">
                                                            <ol className="tableliclass" start="8">
                                                                <li><p className="">You understand the points on
                                                                    which you are prepared to compromise.</p>
                                                                </li>
                                                            </ol>
                                                        </td>
                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item8"
                                                                   id="81"
                                                                   value="1"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item8 === 1}/>
                                                            <label className="cursor-pointer" htmlFor="81">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item8"
                                                                   id="82"
                                                                   value="2"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item8 === 2}/>
                                                            <label className="cursor-pointer" htmlFor="82">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item8"
                                                                   id="83"
                                                                   value="3"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item8 === 3}/>
                                                            <label className="cursor-pointer" htmlFor="83">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item8"
                                                                   id="84"
                                                                   value="4"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item8 === 4}/>
                                                            <label className="cursor-pointer" htmlFor="84">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item8"
                                                                   id="85"
                                                                   value="5"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item8 === 5}/>
                                                            <label className="cursor-pointer" htmlFor="85">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item8"
                                                                   id="86"
                                                                   value="6"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item8 === 6}/>
                                                            <label className="cursor-pointer" htmlFor="86">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item8"
                                                                   id="87"
                                                                   value="7"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item8 === 7}/>
                                                            <label className="cursor-pointer" htmlFor="87">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item8"
                                                                   id="88"
                                                                   value="8"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item8 === 8}/>
                                                            <label className="cursor-pointer" htmlFor="88">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item8"
                                                                   id="89"
                                                                   value="9"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item8 === 9}/>
                                                            <label className="cursor-pointer" htmlFor="89">&nbsp;</label>
                                                        </td>


                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen">
                                                            <ol className="tableliclass" start="9">
                                                                <li><p className="">You tailor your idea to meet
                                                                    the needs of the audience.</p></li>
                                                            </ol>
                                                        </td>
                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item9"
                                                                   id="91"
                                                                   value="1"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item9 === 1}/>
                                                            <label className="cursor-pointer" htmlFor="91">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item9"
                                                                   id="92"
                                                                   value="2"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item9 === 2}/>
                                                            <label className="cursor-pointer" htmlFor="92">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item9"
                                                                   id="93"
                                                                   value="3"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item9 === 3}/>
                                                            <label className="cursor-pointer" htmlFor="93">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item9"
                                                                   id="94"
                                                                   value="4"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item9 === 4}/>
                                                            <label className="cursor-pointer" htmlFor="94">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item9"
                                                                   id="95"
                                                                   value="5"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item9 === 5}/>
                                                            <label className="cursor-pointer" htmlFor="95">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item9"
                                                                   id="96"
                                                                   value="6"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item9 === 6}/>
                                                            <label className="cursor-pointer" htmlFor="96">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item9"
                                                                   id="97"
                                                                   value="7"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item9 === 7}/>
                                                            <label className="cursor-pointer" htmlFor="97">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item9"
                                                                   id="98"
                                                                   value="8"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item9 === 8}/>
                                                            <label className="cursor-pointer" htmlFor="98">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item9"
                                                                   id="99"
                                                                   value="9"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item9 === 9}/>
                                                            <label className="cursor-pointer" htmlFor="99">&nbsp;</label>
                                                        </td>


                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">
                                                            <ol className="tableliclass" start="10">
                                                                <li><p className="">You outline the idea in a
                                                                    logical order.</p></li>
                                                            </ol>
                                                        </td>
                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item10"
                                                                   id="101"
                                                                   value="1"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item10 === 1}/>
                                                            <label className="cursor-pointer" htmlFor="101">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item10"
                                                                   id="102"
                                                                   value="2"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item10 === 2}/>
                                                            <label className="cursor-pointer" htmlFor="102">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item10"
                                                                   id="103"
                                                            value="3"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item10 === 3}/>
                                                            <label className="cursor-pointer" htmlFor="103">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item10"
                                                                   id="104"
                                                                   value="4"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item10 === 4}/>
                                                            <label className="cursor-pointer" htmlFor="104">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item10"
                                                                   id="105"
                                                                   value="5"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item10 === 5}/>
                                                            <label className="cursor-pointer" htmlFor="105">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item10"
                                                                   id="106"
                                                                   value="6"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item10 === 6}/>
                                                            <label className="cursor-pointer" htmlFor="106">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item10"
                                                                   id="107"
                                                                   value="7"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item10 === 7}/>
                                                            <label className="cursor-pointer" htmlFor="107">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item10"
                                                                   id="108"
                                                                   value="8"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item10 === 8}/>
                                                            <label className="cursor-pointer" htmlFor="108">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item10"
                                                                   id="109"
                                                                   value="9"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item10 === 9}/>
                                                            <label className="cursor-pointer" htmlFor="109">&nbsp;</label>
                                                        </td>


                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen">
                                                            <ol className="tableliclass" start="11">
                                                                <li><p className="">You point out the innovative
                                                                    aspects of your idea.</p></li>
                                                            </ol>
                                                        </td>
                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item11"
                                                                   id="111"
                                                                   value="1"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item11 === 1}/>
                                                            <label className="cursor-pointer" htmlFor="111">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item11"
                                                                   id="112"
                                                                   value="2"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item11 === 2}/>
                                                            <label className="cursor-pointer" htmlFor="112">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item11"
                                                                   id="113"
                                                                   value="3"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item11 === 3}/>
                                                            <label className="cursor-pointer" htmlFor="113">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item11"
                                                                   id="114"
                                                                   value="4"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item11 === 4}/>
                                                            <label className="cursor-pointer" htmlFor="114">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item11"
                                                                   id="115"
                                                                   value="5"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item11 === 5}/>
                                                            <label className="cursor-pointer" htmlFor="115">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item11"
                                                                   id="116"
                                                                   value="6"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item11 === 6}/>
                                                            <label className="cursor-pointer" htmlFor="116">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item11"
                                                                   id="117"
                                                                   value="7"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item11 === 7}/>
                                                            <label className="cursor-pointer" htmlFor="117">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item11"
                                                                   id="118"
                                                                   value="8"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item11 === 8}/>
                                                            <label className="cursor-pointer" htmlFor="118">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item11"
                                                                   id="119"
                                                                   value="9"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item11 === 9}/>
                                                            <label className="cursor-pointer" htmlFor="119">&nbsp;</label>
                                                        </td>


                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">
                                                            <ol className="tableliclass" start="12">
                                                                <li><p className="">You actively seek to promote
                                                                    your ideas..</p></li>
                                                            </ol>
                                                        </td>
                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item12"
                                                                   id="121"
                                                                   value="1"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item12 === 1}/>
                                                            <label className="cursor-pointer" htmlFor="121">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item12"
                                                                   id="122"
                                                                   value="2"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item12 === 2}/>
                                                            <label className="cursor-pointer" htmlFor="122">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item12"
                                                                   id="123"
                                                                   value="3"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item12 === 3}/>
                                                            <label className="cursor-pointer" htmlFor="123">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item12"
                                                                   id="124"
                                                                   value="4"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item12 === 4}/>
                                                            <label className="cursor-pointer" htmlFor="124">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item12"
                                                                   id="125"
                                                                   value="5"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item12 === 5}/>
                                                            <label className="cursor-pointer" htmlFor="125">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item12"
                                                                   id="126"
                                                                   value="6"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item12 === 6}/>
                                                            <label className="cursor-pointer" htmlFor="126">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item12"
                                                                   id="127"
                                                                   value="7"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item12 === 7}/>
                                                            <label className="cursor-pointer" htmlFor="127">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item12"
                                                                   id="128"
                                                                   value="8"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item12 === 8}/>
                                                            <label className="cursor-pointer" htmlFor="128">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item12"
                                                                   id="129"
                                                                   value="9"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item12 === 9}/>
                                                            <label className="cursor-pointer" htmlFor="129">&nbsp;</label>
                                                        </td>


                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen">
                                                            <ol className="tableliclass" start="13">
                                                                <li><p className="">You adapt your approach
                                                                    according to different people's agendas.</p>
                                                                </li>
                                                            </ol>
                                                        </td>
                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item13"
                                                                   id="131"
                                                                   value="1"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item13 === 1}/>
                                                            <label className="cursor-pointer" htmlFor="131">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item13"
                                                                   id="132"
                                                                   value="2"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item13 === 2}/>
                                                            <label className="cursor-pointer" htmlFor="132">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item13"
                                                                   id="133"
                                                                   value="3"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item13 === 3}/>
                                                            <label className="cursor-pointer" htmlFor="133">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item13"
                                                                   id="134"
                                                                   value="4"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item13 === 4}/>
                                                            <label className="cursor-pointer" htmlFor="134">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item13"
                                                                   id="135"
                                                                   value="5"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item13 === 5}/>
                                                            <label className="cursor-pointer" htmlFor="135">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item13"
                                                                   id="136"
                                                                   value="6"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item13 === 6}/>
                                                            <label className="cursor-pointer" htmlFor="136">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item13"
                                                                   id="137"
                                                                   value="7"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item13 === 7}/>
                                                            <label className="cursor-pointer" htmlFor="137">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item13"
                                                                   id="138"
                                                                   value="8"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item13 === 8}/>
                                                            <label className="cursor-pointer" htmlFor="138">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item13"
                                                                   id="139"
                                                                   value="9"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item13 === 9}/>
                                                            <label className="cursor-pointer" htmlFor="139">&nbsp;</label>
                                                        </td>


                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">
                                                            <ol className="tableliclass" start="14">
                                                                <li><p className="">You outline the pros and
                                                                    cons of your idea.</p></li>
                                                            </ol>
                                                        </td>
                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item14"
                                                                   id="141"
                                                                   value="1"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item14 === 1}/>
                                                            <label className="cursor-pointer" htmlFor="141">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item14"
                                                                   id="142"
                                                                   value="2"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item14 === 2}/>
                                                            <label className="cursor-pointer" htmlFor="142">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item14"
                                                                   id="143"
                                                                   value="3"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item14 === 3}/>
                                                            <label className="cursor-pointer" htmlFor="143">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item14"
                                                                   id="144"
                                                                   value="4"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item14 === 4}/>
                                                            <label className="cursor-pointer" htmlFor="144">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item14"
                                                                   id="145"
                                                                   value="5"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item14 === 5}/>
                                                            <label className="cursor-pointer" htmlFor="145">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item14"
                                                                   id="146"
                                                                   value="6"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item14 === 6}/>
                                                            <label className="cursor-pointer" htmlFor="146">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item14"
                                                                   id="147"
                                                                   value="7"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item14 === 7}/>
                                                            <label className="cursor-pointer" htmlFor="147">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item14"
                                                                   id="148"
                                                                   value="8"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item14 === 8}/>
                                                            <label className="cursor-pointer" htmlFor="148">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item14"
                                                                   id="149"
                                                                   value="9"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item14 === 9}/>
                                                            <label className="cursor-pointer" htmlFor="149">&nbsp;</label>
                                                        </td>


                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen">
                                                            <ol className="tableliclass" start="15">
                                                                <li><p className="">You highlight the ways in
                                                                    which your idea is better than
                                                                    alternatives.</p></li>
                                                            </ol>
                                                        </td>
                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item15"
                                                                   id="151"
                                                                   value="1"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item15 === 1}/>
                                                            <label className="cursor-pointer" htmlFor="151">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item15"
                                                                   id="152"
                                                                   value="2"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item15 === 2}/>
                                                            <label className="cursor-pointer" htmlFor="152">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item15"
                                                                   id="153"
                                                                   value="3"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item15 === 3}/>
                                                            <label className="cursor-pointer" htmlFor="153">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item15"
                                                                   id="154"
                                                                   value="4"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item15 === 4}/>
                                                            <label className="cursor-pointer" htmlFor="154">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item15"
                                                                   id="155"
                                                                   value="5"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item15 === 5}/>
                                                            <label className="cursor-pointer" htmlFor="155">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item15"
                                                                   id="156"
                                                                   value="6"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item15 === 6}/>
                                                            <label className="cursor-pointer" htmlFor="156">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item15"
                                                                   id="157"
                                                                   value="7"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item15 === 7}/>
                                                            <label className="cursor-pointer" htmlFor="157">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item15"
                                                                   id="158"
                                                                   value="8"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item15 === 8}/>
                                                            <label className="cursor-pointer" htmlFor="158">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item15"
                                                                   id="159"
                                                                   value="9"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item15 === 9}/>
                                                            <label className="cursor-pointer" htmlFor="159">&nbsp;</label>
                                                        </td>


                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">
                                                            <ol className="tableliclass" start="16">
                                                                <li><p className="">You ensure that you gain
                                                                    some kind of commitment when you have
                                                                    proposed your idea.</p></li>
                                                            </ol>
                                                        </td>
                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item16"
                                                                   id="161"
                                                                   value="1"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item16 === 1}/>
                                                            <label className="cursor-pointer" htmlFor="161">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item16"
                                                                   id="162"
                                                                   value="2"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item16 === 2}/>
                                                            <label className="cursor-pointer" htmlFor="162">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item16"
                                                                   id="163"
                                                                   value="3"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item16 === 3}/>
                                                            <label className="cursor-pointer" htmlFor="163">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item16"
                                                                   id="164"
                                                            value="4"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item16 === 4}/>
                                                            <label className="cursor-pointer" htmlFor="164">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item16"
                                                                   id="165"
                                                                   value="5"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item16 === 5}/>
                                                            <label className="cursor-pointer" htmlFor="165">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item16"
                                                                   id="166"
                                                                   value="6"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item16 === 6}/>
                                                            <label className="cursor-pointer" htmlFor="166">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item16"
                                                                   id="167"
                                                                   value="7"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item16 === 7}/>
                                                            <label className="cursor-pointer" htmlFor="167">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item16"
                                                                   id="168"
                                                                   value="8"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item16 === 8}/>
                                                            <label className="cursor-pointer" htmlFor="168">&nbsp;</label>
                                                        </td>


                                                        <td width="5%" align="center" valign="center"
                                                            className="lightgreen">
                                                            <input type="checkbox"
                                                                   style={{marginLeft: '10px'}}
                                                                   name="Item16"
                                                                   id="169"
                                                                   value="9"
                                                                   onChange={this.props.handleChangePageData}
                                                                   checked={pageData?.Item16 === 9}/>
                                                            <label className="cursor-pointer" htmlFor="169">&nbsp;</label>
                                                        </td>


                                                    </tr>


                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="circle_title"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>SCORING
                                            </div>
                                            <p>Add up each ‘area’ score, on this table:</p>

                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport tablesrink">
                                                <tbody>
                                                <tr>
                                                    <th width="30%" align="left" valign="top"
                                                        className="green_curve ">Area
                                                    </th>
                                                    <th width="30%" align="left" valign="top">Item to Add</th>
                                                    <th width="30%" align="left" valign="top"
                                                        className=" green_curve1">Total Score
                                                    </th>

                                                </tr>
                                                <tr>
                                                    <td className="lightgreen">The Art of Persuasion</td>
                                                    <td align="center" className="lightgreen">1 + 5 + 9 + 13
                                                    </td>
                                                    <td align="center" className="lightgreen">
                                                        {(pageData?.Item1 || 0) + (pageData?.Item5 || 0) + (pageData?.Item9 || 0) + (pageData?.Item13 || 0)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen">Logical Facts</td>
                                                    <td align="center" className="darkgreen">2 + 6 + 10 + 14
                                                    </td>
                                                    <td align="center" className="darkgreen">
                                                        {(pageData?.Item2 || 0) + (pageData?.Item6 || 0) + (pageData?.Item10 || 0) + (pageData?.Item14 || 0)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen">Sell the Benefits</td>
                                                    <td align="center" className="lightgreen">3 + 7 + 11 + 15
                                                    </td>
                                                    <td align="center" className="lightgreen">
                                                        {(pageData?.Item3 || 0) + (pageData?.Item7 || 0) + (pageData?.Item11 || 0) + (pageData?.Item15 || 0)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen">Negotiate the Deal</td>
                                                    <td align="center" className="darkgreen">4 + 8 + 12 + 16
                                                    </td>
                                                    <td align="center" className="darkgreen">
                                                        {(pageData?.Item4 || 0) + (pageData?.Item8 || 0) + (pageData?.Item12 || 0) + (pageData?.Item16 || 0)}
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>

                                            <p>The higher the score, out of a possible 36 for each ‘area’, the
                                                more you’ll tend to rely on it.
                                                You’re likely to use one as your primary method, but most of us
                                                will also use the other methods
                                                as a secondary measure to mix things up. The pie chart shows the
                                                prevalence of methods in a
                                                hypothetical individual who has taken the test.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page7')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}